import { useEffect, useState } from "react"
import { useAppDispatch, useAppSelector } from '../../lib/redux/hooks'
import { Layout } from "../../ui/layout"
import { CustomHorizontalTab } from "../../ui/organisms/customHorizontalTab"
import { MenuItems } from "../../ui/organisms/navbar/dto"
import { GetByIdAnagraphic, resetGetByIdStatus } from '../gestionePersonale/boxAnagrafica/slice'
import { GetAllPersonalManagement, resetGetAllPersonalManagementResourcesStatus } from '../gestionePersonale/slice'
import { addPMResource } from './slice'
import { GestionePrelieviEdit } from './edit'
import { GestionePrelieviList } from './list'
import { GestionePrelieviLoadAssign } from "./loadAssign"

export function GestionePrelievi() {
    const dispatch = useAppDispatch()
    const personalManagementState = useAppSelector(state => state.personalManagement)
    const anagraficaState = useAppSelector(state => state.PMAnagrafica)
    const [selectedTab, setSelectedTab] = useState<number>(0)

    useEffect(() => {
        dispatch(GetAllPersonalManagement({ itemsPerPage: 0, page: 0, function: 'PERSONALE_ISPETTIVO' }))
    }, [])

    useEffect(() => {
        if (
            personalManagementState.getAllPersonalManagementResourcesStatus === 'successfully' &&
            personalManagementState.getAllPersonalManagementResourcesResponse !== undefined
        ) {
            dispatch(resetGetAllPersonalManagementResourcesStatus())
            const data = personalManagementState.getAllPersonalManagementResourcesResponse.data
            for (let i = 0; i < data.length; i++) {
                dispatch(GetByIdAnagraphic(String(data[i].anagraphicId)))
            }
        }
    }, [personalManagementState.getAllPersonalManagementResourcesStatus])

    useEffect(() => {
        if (
            anagraficaState.GetByIdAnagraphicStatus === 'successfully' &&
            anagraficaState.getByIdAnagraphicRequest !== undefined
        ) {
            dispatch(resetGetByIdStatus('idle'))
            const data = anagraficaState.getByIdAnagraphicRequest
            dispatch(addPMResource({ value: data.personalManagementId, label: `${data.name} ${data.surname}` }))
        }
    }, [anagraficaState.GetByIdAnagraphicStatus])

    return (
        <Layout
            menuItem={MenuItems.GESTIONE_CONTROLLO}
            breadcrumbItems={['Gestione Controllo', 'Gestione Prelievi']}
            noPaddingLat
            headerLabel="Gestione Prelievi"
        >
            <CustomHorizontalTab
                selectedIndex={selectedTab}
                onTabClick={(index) => setSelectedTab(index)}
            >
                <div>Carica/Assegna</div>
                <div>Modifica</div>
                <div>Consultazione</div>
            </CustomHorizontalTab>
            <div className="bg-brandPrimary-200 p-6">
                {selectedTab === 0 && <GestionePrelieviLoadAssign />}
                {selectedTab === 1 && <GestionePrelieviEdit />}
                {selectedTab === 2 && <GestionePrelieviList />}
            </div>
        </Layout>
    )
}